import styled from 'styled-components';

export default styled.div`
  font-weight: 500;
  text-align: center;
`;
